<template>
  <div class="tech-dropdown">
    <div class="tech-dropdown-menu">
      <ul>
        <li>
          <a
            href="javascript:void(0);"
            class="menu-item"
            @click="onItemClick('add')"
          >
            <i class="material-icons-outlined align-middle">assignment_ind</i>
            Add User
          </a>
        </li>
        <li>
          <a
            href="javascript:void(0);"
            class="menu-item"
            @click="onItemClick('create')"
          >
            <i class="material-icons-outlined align-middle">credit_card</i>
            Create Invoice
          </a>
        </li>
        <li>
          <a
            href="javascript:void(0);"
            class="menu-item"
            @click="onItemClick('edit')"
          >
            <i class="material-icons-outlined align-middle">info</i>
            Edit
          </a>
        </li>
        <li>
          <a
            href="javascript:void(0);"
            class="menu-item"
            @click="onItemClick('delete')"
          >
            <i class="material-icons-outlined align-middle">delete</i>
            Delete
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onItemClick: function (item) {
      this.$emit("dropdownClick", item);
    },
  },
};
</script>

<style scoped>
.menu-item {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
</style>
